import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Box,
  TextField,
  Button,
  Divider,
} from "@mui/material";
import { InfoField } from "@/components/InfoField";
import type { LogList } from "@/api/log.service";

type Props = {
  open: boolean;
  log: LogList | null;
  onClose: () => void;
};

export const LogDetailsDialog = ({ open, log, onClose }: Props) => {
  if (!log) return null;

  const companies = Array.isArray(log.user_company) ? log.user_company.join(", ") : log.user_company;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth fullScreen={false}>
      <DialogTitle>
        Detalhes do Log
        <Typography variant="body2" color="text.secondary" ml={2} display="inline">
          {log.created_at}
        </Typography>
      </DialogTitle>

      <DialogContent dividers>
        <Box
          display="grid"
          gridTemplateColumns={{ xs: '1fr', sm: '1fr 1fr' }}
          gap={2}
          mb={3}
        >
          <InfoField label="Evento" value={log.event_type} />
          <InfoField label="Nível" value={log.level} />
          <InfoField label="ID Ator" value={log.actor_id} />
          <InfoField label="Ator" value={log.username} />
          <InfoField label="Empresa" value={companies} />
          <InfoField label="Cliente" value={log.client_name ?? undefined} />
          <InfoField label="Módulo" value={log.module_id ?? undefined} />
          <InfoField label="Entidade" value={log.entity_name} />
          <InfoField label="ID Entidade" value={log.entity_id} />
        </Box>

        <Divider sx={{ mb: 2 }} />

        <Typography variant="subtitle2" mb={1}>
          Payload
        </Typography>

        <TextField
          fullWidth
          multiline
          minRows={10}
          value={log.payload}
          slotProps={{
            input: {
              readOnly: true
            }
          }}
        />
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose}>Fechar</Button>
      </DialogActions>
    </Dialog>
  );
};
